module.exports = __webpack_public_path__ + "img/new_dianzhao_1.e3cf7f78.png";